import { GraphApprovalStatus } from "@custom-types/graphs"
import { CheckCircle, ErrorRounded, WatchLater } from "@mui/icons-material"
import { DefaultComponentProps, OverridableTypeMap } from "@mui/material/OverridableComponent"

type ApprovalStatusIconProps = DefaultComponentProps<OverridableTypeMap> & {
  status: GraphApprovalStatus
}

const iconColor: Record<GraphApprovalStatus, string> = {
  [GraphApprovalStatus.Denied]: "#ef0000",
  [GraphApprovalStatus.Waiting]: "#e19d21",
  [GraphApprovalStatus.Approved]: "#2a862a",
}

const ApprovalStatusIcon = ({ status, ...props }: ApprovalStatusIconProps) => {
  const sx = {
    fontSize: 20,
    color: iconColor[status],
    ...props?.sx,
  }

  switch (status) {
    case GraphApprovalStatus.Approved:
      return <CheckCircle sx={sx} />
    case GraphApprovalStatus.Denied:
      return <ErrorRounded sx={sx} />
    case GraphApprovalStatus.Waiting:
      return <WatchLater sx={sx} />
    default:
      return <></>
  }
}

export default ApprovalStatusIcon
